export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-clipboard-a6c10e49ba47deb30a5c7a6aba6507e2.svg";